import { SOCIAL_LINKS } from './links';

import IconDiscord from '@/assets/svg/icon_discord.svg?react';
import IconTelegram from '@/assets/svg/icon_telegram.svg?react';
import IconTwitter from '@/assets/svg/icon_twitter.svg?react';
import IconYoutube from '@/assets/svg/icon_youtube.svg?react';
type TSocialInfo = {
  icon: JSX.Element;
  href: string;
};

export enum SocialId {
  TWITTER = 'TWITTER',
  // MEDIUM = 'MEDIUM',
  DISCORD = 'DISCORD',
  YOUTUBE = 'YOUTUBE',
  TELEGRAM = 'TELEGRAM',
}
export const socialInfos: { [id in SocialId]: TSocialInfo } = {
  [SocialId.TWITTER]: {
    icon: <IconTwitter />,
    href: SOCIAL_LINKS.TWITTER,
  },
  // [SocialId.MEDIUM]: {
  //   icon: <IconMedium />,
  //   href: 'https://medium.com/synfutures',
  // },
  [SocialId.DISCORD]: {
    icon: <IconDiscord />,
    href: SOCIAL_LINKS.DISCORD,
  },
  [SocialId.YOUTUBE]: {
    icon: <IconYoutube />,
    href: 'https://www.youtube.com/channel/UCRHA7TThDHr7hGxtvM5_3vQ',
  },
  [SocialId.TELEGRAM]: {
    icon: <IconTelegram />,
    href: SOCIAL_LINKS.TELEGRAM,
  },
};
